import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Features from "@/pages/features/page";
import AiTaskBreakdown from "@/pages/features/ai-task-breakdown/page";
import AiGantt from "@/pages/features/ai-gantt/page";
import AiDailyReport from "@/pages/features/ai-daily-report/page";
import AiFileManagement from "@/pages/features/ai-file-management/page";
import TeamCollaboration from "@/pages/features/team-collaboration/page";
import Multilingual from "@/pages/features/multilingual/page";
import Pricing from "@/pages/pricing/page";
import Security from "@/pages/security/page";
import FreeTrial from "@/pages/free-trial/page";
import Contact from "@/pages/contact/page";
import ComparePMTools from "@/pages/compare/project-management-tools/page";
import CompareExcel from "@/pages/compare/excel-vs-project-management-tool/page";
import CompareSpreadsheet from "@/pages/compare/spreadsheet-vs-project-management-tool/page";
import CompareAIPM from "@/pages/compare/ai-project-management-tools/page";
import CompareGantt from "@/pages/compare/gantt-chart-tools/page";
import TemplatePMExcel from "@/pages/templates/project-management-excel/page";
import TemplateGantt from "@/pages/templates/gantt-chart-excel/page";
import TemplateWBS from "@/pages/templates/wbs/page";
import TemplateStatusReport from "@/pages/templates/project-status-report/page";
import GuidePM from "@/pages/guides/project-management/page";
import GuidePMTool from "@/pages/guides/project-management-tool/page";
import GuidePMAI from "@/pages/guides/project-management-ai/page";
import GuideWBS from "@/pages/guides/wbs/page";
import GuideWBSGantt from "@/pages/guides/wbs-and-gantt-chart/page";
import GuideGantt from "@/pages/guides/gantt-chart/page";
import GuideProgress from "@/pages/guides/project-progress-management/page";
import GuideVisualization from "@/pages/guides/project-visualization/page";
import GuideDailyReport from "@/pages/guides/project-daily-report/page";
import GuideSchedule from "@/pages/guides/project-schedule-management/page";
import GuideTask from "@/pages/guides/project-task-management/page";
import GuideInfoSharing from "@/pages/guides/project-information-sharing/page";
import GuideDocManagement from "@/pages/guides/project-document-management/page";
import GuideMilestone from "@/pages/guides/project-milestone/page";
import GuideDependency from "@/pages/guides/project-dependency/page";
import GuideCriticalPath from "@/pages/guides/critical-path/page";
import GuidePMFailure from "@/pages/guides/project-management-failure/page";
import GuideGlobalPM from "@/pages/guides/global-project-management/page";
import Terms from "@/pages/terms/page";
import Privacy from "@/pages/privacy/page";
import CommercialLaw from "@/pages/commercial-law/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/features/", element: <Features /> },
  { path: "/features/ai-task-breakdown/", element: <AiTaskBreakdown /> },
  { path: "/features/ai-gantt/", element: <AiGantt /> },
  { path: "/features/ai-daily-report/", element: <AiDailyReport /> },
  { path: "/features/ai-file-management/", element: <AiFileManagement /> },
  { path: "/features/team-collaboration/", element: <TeamCollaboration /> },
  { path: "/features/multilingual/", element: <Multilingual /> },
  { path: "/pricing/", element: <Pricing /> },
  { path: "/security/", element: <Security /> },
  { path: "/free-trial/", element: <FreeTrial /> },
  { path: "/contact/", element: <Contact /> },
  { path: "/compare/project-management-tools/", element: <ComparePMTools /> },
  { path: "/compare/excel-vs-project-management-tool/", element: <CompareExcel /> },
  { path: "/compare/spreadsheet-vs-project-management-tool/", element: <CompareSpreadsheet /> },
  { path: "/compare/ai-project-management-tools/", element: <CompareAIPM /> },
  { path: "/compare/gantt-chart-tools/", element: <CompareGantt /> },
  { path: "/templates/project-management-excel/", element: <TemplatePMExcel /> },
  { path: "/templates/gantt-chart-excel/", element: <TemplateGantt /> },
  { path: "/templates/wbs/", element: <TemplateWBS /> },
  { path: "/templates/project-status-report/", element: <TemplateStatusReport /> },
  { path: "/guides/project-management/", element: <GuidePM /> },
  { path: "/guides/project-management-tool/", element: <GuidePMTool /> },
  { path: "/guides/project-management-ai/", element: <GuidePMAI /> },
  { path: "/guides/wbs/", element: <GuideWBS /> },
  { path: "/guides/wbs-and-gantt-chart/", element: <GuideWBSGantt /> },
  { path: "/guides/gantt-chart/", element: <GuideGantt /> },
  { path: "/guides/project-progress-management/", element: <GuideProgress /> },
  { path: "/guides/project-visualization/", element: <GuideVisualization /> },
  { path: "/guides/project-daily-report/", element: <GuideDailyReport /> },
  { path: "/guides/project-schedule-management/", element: <GuideSchedule /> },
  { path: "/guides/project-task-management/", element: <GuideTask /> },
  { path: "/guides/project-information-sharing/", element: <GuideInfoSharing /> },
  { path: "/guides/project-document-management/", element: <GuideDocManagement /> },
  { path: "/guides/project-milestone/", element: <GuideMilestone /> },
  { path: "/guides/project-dependency/", element: <GuideDependency /> },
  { path: "/guides/critical-path/", element: <GuideCriticalPath /> },
  { path: "/guides/project-management-failure/", element: <GuidePMFailure /> },
  { path: "/guides/global-project-management/", element: <GuideGlobalPM /> },
  { path: "/terms/", element: <Terms /> },
  { path: "/privacy/", element: <Privacy /> },
  { path: "/commercial-law/", element: <CommercialLaw /> },
  { path: "*", element: <NotFound /> },
];

export default routes;